const ControlType = {
    start: 0,
    control: 1,
    finish: 2
};

export default ControlType;